// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"ad1c85c044bcbb964ae4","293":"923431c87776d21db30e"}[chunkId] + ".js";
};